import { renderCardHeader_unstable } from '@fluentui/react-card';

/**
 * Renders the final JSX of the CardHeader component, given the state.
 */
export const renderCardHeader = renderCardHeader_unstable;
